export default __webpack_public_path__ + "static/media/image_placeholder.c8227297.svg";